/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesScorecardsApplicationScorecardsScorecardResponse } from '../model/modulesScorecardsApplicationScorecardsScorecardResponse';
import { ModulesScorecardsApplicationScoresRemoveScoresForRoundRemoveScoresForRoundResponse } from '../model/modulesScorecardsApplicationScoresRemoveScoresForRoundRemoveScoresForRoundResponse';
import { ModulesScorecardsApplicationScoresScoreResponse } from '../model/modulesScorecardsApplicationScoresScoreResponse';
import { ModulesScorecardsApplicationShotFromsGetShotFromsShotFromResponse } from '../model/modulesScorecardsApplicationShotFromsGetShotFromsShotFromResponse';
import { ModulesScorecardsApplicationShotTypesGetShotTypesShotTypeResponse } from '../model/modulesScorecardsApplicationShotTypesGetShotTypesShotTypeResponse';
import { ModulesScorecardsEndpointsContractsCourseAssignmentsAssignPlayersToCourseRequest } from '../model/modulesScorecardsEndpointsContractsCourseAssignmentsAssignPlayersToCourseRequest';
import { ModulesScorecardsEndpointsContractsCourseAssignmentsAssignPlayersToCourseResponse } from '../model/modulesScorecardsEndpointsContractsCourseAssignmentsAssignPlayersToCourseResponse';
import { ModulesScorecardsEndpointsContractsCourseAssignmentsBulkAssignRequest } from '../model/modulesScorecardsEndpointsContractsCourseAssignmentsBulkAssignRequest';
import { ModulesScorecardsEndpointsContractsCourseAssignmentsBulkAssignResponse } from '../model/modulesScorecardsEndpointsContractsCourseAssignmentsBulkAssignResponse';
import { ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentCourseResponse } from '../model/modulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentCourseResponse';
import { ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentPlayersResponse } from '../model/modulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentPlayersResponse';
import { ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentSummaryResponse } from '../model/modulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentSummaryResponse';
import { ModulesScorecardsEndpointsContractsScorecardsCreateScorecardRequest } from '../model/modulesScorecardsEndpointsContractsScorecardsCreateScorecardRequest';
import { ModulesScorecardsEndpointsContractsScorecardsMarkScorecardOfficialRequestModel } from '../model/modulesScorecardsEndpointsContractsScorecardsMarkScorecardOfficialRequestModel';
import { ModulesScorecardsEndpointsContractsScorecardsMarkScorecardVerifiedRequestModel } from '../model/modulesScorecardsEndpointsContractsScorecardsMarkScorecardVerifiedRequestModel';
import { ModulesScorecardsEndpointsContractsScorecardsUpdateScorecardRequestModel } from '../model/modulesScorecardsEndpointsContractsScorecardsUpdateScorecardRequestModel';
import { ModulesScorecardsEndpointsContractsScoresCreateScoreRequestModel } from '../model/modulesScorecardsEndpointsContractsScoresCreateScoreRequestModel';
import { ModulesScorecardsEndpointsContractsScoresUpdateScoreRequestModel } from '../model/modulesScorecardsEndpointsContractsScoresUpdateScoreRequestModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { ScorecardsServiceInterface }                            from './scorecards.serviceInterface';


@Injectable()
export class ScorecardsService implements ScorecardsServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Assigns one or more players to a round tournament course.
     * Creates or updates scorecards so that the provided players are associated with the specified round tournament course.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public assignPlayersToCourseEndpoint(body?: ModulesScorecardsEndpointsContractsCourseAssignmentsAssignPlayersToCourseRequest, observe?: 'body', reportProgress?: boolean): Observable<ModulesScorecardsEndpointsContractsCourseAssignmentsAssignPlayersToCourseResponse>;
    public assignPlayersToCourseEndpoint(body?: ModulesScorecardsEndpointsContractsCourseAssignmentsAssignPlayersToCourseRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesScorecardsEndpointsContractsCourseAssignmentsAssignPlayersToCourseResponse>>;
    public assignPlayersToCourseEndpoint(body?: ModulesScorecardsEndpointsContractsCourseAssignmentsAssignPlayersToCourseRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesScorecardsEndpointsContractsCourseAssignmentsAssignPlayersToCourseResponse>>;
    public assignPlayersToCourseEndpoint(body?: ModulesScorecardsEndpointsContractsCourseAssignmentsAssignPlayersToCourseRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ModulesScorecardsEndpointsContractsCourseAssignmentsAssignPlayersToCourseResponse>('post',`${this.basePath}/scorecards/assign-to-course`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Performs a bulk course assignment operation.
     * Supports even, rank-alternate, random, and copy-previous strategies for assigning players to round tournament courses.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bulkAssignEndpoint(body?: ModulesScorecardsEndpointsContractsCourseAssignmentsBulkAssignRequest, observe?: 'body', reportProgress?: boolean): Observable<ModulesScorecardsEndpointsContractsCourseAssignmentsBulkAssignResponse>;
    public bulkAssignEndpoint(body?: ModulesScorecardsEndpointsContractsCourseAssignmentsBulkAssignRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesScorecardsEndpointsContractsCourseAssignmentsBulkAssignResponse>>;
    public bulkAssignEndpoint(body?: ModulesScorecardsEndpointsContractsCourseAssignmentsBulkAssignRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesScorecardsEndpointsContractsCourseAssignmentsBulkAssignResponse>>;
    public bulkAssignEndpoint(body?: ModulesScorecardsEndpointsContractsCourseAssignmentsBulkAssignRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ModulesScorecardsEndpointsContractsCourseAssignmentsBulkAssignResponse>('post',`${this.basePath}/scorecards/bulk-assign`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Clears all course assignments for the specified round.
     * Removes scorecards for the round after validating that no scores or published pairings exist.
     * @param tournamentId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clearAssignmentsEndpoint(tournamentId: string, roundId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public clearAssignmentsEndpoint(tournamentId: string, roundId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public clearAssignmentsEndpoint(tournamentId: string, roundId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public clearAssignmentsEndpoint(tournamentId: string, roundId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling clearAssignmentsEndpoint.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling clearAssignmentsEndpoint.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('tournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('roundId', <any>roundId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/scorecards/assignments`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets tournament players with course assignment metadata.
     * Returns all tournament players for the specified round along with current and previous course assignments.
     * @param tournamentId 
     * @param roundId 
     * @param includeAssignments 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCourseAssignmentPlayersEndpoint(tournamentId: string, roundId: string, includeAssignments?: boolean, observe?: 'body', reportProgress?: boolean): Observable<ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentPlayersResponse>;
    public getCourseAssignmentPlayersEndpoint(tournamentId: string, roundId: string, includeAssignments?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentPlayersResponse>>;
    public getCourseAssignmentPlayersEndpoint(tournamentId: string, roundId: string, includeAssignments?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentPlayersResponse>>;
    public getCourseAssignmentPlayersEndpoint(tournamentId: string, roundId: string, includeAssignments?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getCourseAssignmentPlayersEndpoint.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling getCourseAssignmentPlayersEndpoint.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('tournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('roundId', <any>roundId);
        }
        if (includeAssignments !== undefined && includeAssignments !== null) {
            queryParameters = queryParameters.set('includeAssignments', <any>includeAssignments);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentPlayersResponse>('get',`${this.basePath}/scorecards/tournament-players`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets course assignment summary for the specified round.
     * Returns counts and validation metadata used to drive the course assignment UI state.
     * @param tournamentId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCourseAssignmentSummaryEndpoint(tournamentId: string, roundId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentSummaryResponse>;
    public getCourseAssignmentSummaryEndpoint(tournamentId: string, roundId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentSummaryResponse>>;
    public getCourseAssignmentSummaryEndpoint(tournamentId: string, roundId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentSummaryResponse>>;
    public getCourseAssignmentSummaryEndpoint(tournamentId: string, roundId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getCourseAssignmentSummaryEndpoint.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling getCourseAssignmentSummaryEndpoint.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('tournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('roundId', <any>roundId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentSummaryResponse>('get',`${this.basePath}/scorecards/assignment-summary`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets round course metadata for course assignment UI.
     * Returns the round tournament courses associated with the specified round, including display metadata.
     * @param tournamentId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoundCoursesEndpoint(tournamentId: string, roundId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentCourseResponse>>;
    public getRoundCoursesEndpoint(tournamentId: string, roundId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentCourseResponse>>>;
    public getRoundCoursesEndpoint(tournamentId: string, roundId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentCourseResponse>>>;
    public getRoundCoursesEndpoint(tournamentId: string, roundId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getRoundCoursesEndpoint.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling getRoundCoursesEndpoint.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('tournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('roundId', <any>roundId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesScorecardsEndpointsContractsCourseAssignmentsCourseAssignmentCourseResponse>>('get',`${this.basePath}/scorecards/round-tournament-courses`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Score.
     * Gets a Score using the Score identifier.
     * @param scorecardId 
     * @param scoreId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScoreByIdEndpoint(scorecardId: string, scoreId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesScorecardsApplicationScoresScoreResponse>;
    public getScoreByIdEndpoint(scorecardId: string, scoreId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesScorecardsApplicationScoresScoreResponse>>;
    public getScoreByIdEndpoint(scorecardId: string, scoreId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesScorecardsApplicationScoresScoreResponse>>;
    public getScoreByIdEndpoint(scorecardId: string, scoreId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (scorecardId === null || scorecardId === undefined) {
            throw new Error('Required parameter scorecardId was null or undefined when calling getScoreByIdEndpoint.');
        }

        if (scoreId === null || scoreId === undefined) {
            throw new Error('Required parameter scoreId was null or undefined when calling getScoreByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesScorecardsApplicationScoresScoreResponse>('get',`${this.basePath}/scorecards/${encodeURIComponent(String(scorecardId))}/scores/${encodeURIComponent(String(scoreId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Scorecard.
     * Gets a Scorecard using the Scorecard identifier.
     * @param scorecardId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScorecardByIdEndpoint(scorecardId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesScorecardsApplicationScorecardsScorecardResponse>;
    public getScorecardByIdEndpoint(scorecardId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesScorecardsApplicationScorecardsScorecardResponse>>;
    public getScorecardByIdEndpoint(scorecardId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesScorecardsApplicationScorecardsScorecardResponse>>;
    public getScorecardByIdEndpoint(scorecardId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (scorecardId === null || scorecardId === undefined) {
            throw new Error('Required parameter scorecardId was null or undefined when calling getScorecardByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesScorecardsApplicationScorecardsScorecardResponse>('get',`${this.basePath}/scorecards/${encodeURIComponent(String(scorecardId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets one or more Scorecards.
     * Gets one or more Scorecards by various route and querystring parameters.
     * @param tournamentId 
     * @param roundId 
     * @param courseId 
     * @param playerId 
     * @param teamId 
     * @param groupId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScorecardsEndpoint(tournamentId?: string, roundId?: string, courseId?: string, playerId?: string, teamId?: string, groupId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesScorecardsApplicationScorecardsScorecardResponse>>;
    public getScorecardsEndpoint(tournamentId?: string, roundId?: string, courseId?: string, playerId?: string, teamId?: string, groupId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesScorecardsApplicationScorecardsScorecardResponse>>>;
    public getScorecardsEndpoint(tournamentId?: string, roundId?: string, courseId?: string, playerId?: string, teamId?: string, groupId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesScorecardsApplicationScorecardsScorecardResponse>>>;
    public getScorecardsEndpoint(tournamentId?: string, roundId?: string, courseId?: string, playerId?: string, teamId?: string, groupId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('TournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('RoundId', <any>roundId);
        }
        if (courseId !== undefined && courseId !== null) {
            queryParameters = queryParameters.set('CourseId', <any>courseId);
        }
        if (playerId !== undefined && playerId !== null) {
            queryParameters = queryParameters.set('PlayerId', <any>playerId);
        }
        if (teamId !== undefined && teamId !== null) {
            queryParameters = queryParameters.set('TeamId', <any>teamId);
        }
        if (groupId !== undefined && groupId !== null) {
            queryParameters = queryParameters.set('GroupId', <any>groupId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesScorecardsApplicationScorecardsScorecardResponse>>('get',`${this.basePath}/scorecards`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets Scores.
     * Gets Scores using the Scorecard identifier.
     * @param scorecardId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScoresByScorecardEndpoint(scorecardId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesScorecardsApplicationScoresScoreResponse>>;
    public getScoresByScorecardEndpoint(scorecardId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesScorecardsApplicationScoresScoreResponse>>>;
    public getScoresByScorecardEndpoint(scorecardId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesScorecardsApplicationScoresScoreResponse>>>;
    public getScoresByScorecardEndpoint(scorecardId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (scorecardId === null || scorecardId === undefined) {
            throw new Error('Required parameter scorecardId was null or undefined when calling getScoresByScorecardEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesScorecardsApplicationScoresScoreResponse>>('get',`${this.basePath}/scorecards/${encodeURIComponent(String(scorecardId))}/scores`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets ShotFroms.
     * Retrieves a list of ShotFroms.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getShotFromsEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesScorecardsApplicationShotFromsGetShotFromsShotFromResponse>>;
    public getShotFromsEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesScorecardsApplicationShotFromsGetShotFromsShotFromResponse>>>;
    public getShotFromsEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesScorecardsApplicationShotFromsGetShotFromsShotFromResponse>>>;
    public getShotFromsEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesScorecardsApplicationShotFromsGetShotFromsShotFromResponse>>('get',`${this.basePath}/shotfroms`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets ShotTypes.
     * Retrieves a list of ShotTypes.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getShotTypesEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesScorecardsApplicationShotTypesGetShotTypesShotTypeResponse>>;
    public getShotTypesEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesScorecardsApplicationShotTypesGetShotTypesShotTypeResponse>>>;
    public getShotTypesEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesScorecardsApplicationShotTypesGetShotTypesShotTypeResponse>>>;
    public getShotTypesEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesScorecardsApplicationShotTypesGetShotTypesShotTypeResponse>>('get',`${this.basePath}/shottypes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a player from their course assignment for the specified round.
     * Deletes the player&#x27;s scorecard for the round tournament course when no scores exist.
     * @param roundTournamentCourseId 
     * @param businessEntityId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removePlayerAssignmentEndpoint(roundTournamentCourseId: number, businessEntityId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public removePlayerAssignmentEndpoint(roundTournamentCourseId: number, businessEntityId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public removePlayerAssignmentEndpoint(roundTournamentCourseId: number, businessEntityId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public removePlayerAssignmentEndpoint(roundTournamentCourseId: number, businessEntityId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (roundTournamentCourseId === null || roundTournamentCourseId === undefined) {
            throw new Error('Required parameter roundTournamentCourseId was null or undefined when calling removePlayerAssignmentEndpoint.');
        }

        if (businessEntityId === null || businessEntityId === undefined) {
            throw new Error('Required parameter businessEntityId was null or undefined when calling removePlayerAssignmentEndpoint.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (roundTournamentCourseId !== undefined && roundTournamentCourseId !== null) {
            queryParameters = queryParameters.set('roundTournamentCourseId', <any>roundTournamentCourseId);
        }
        if (businessEntityId !== undefined && businessEntityId !== null) {
            queryParameters = queryParameters.set('businessEntityId', <any>businessEntityId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/scorecards/assignment`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Scorecard.
     * Creates a Scorecard based on the CreateScorecardRequest request.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public scorecardsPost(body?: ModulesScorecardsEndpointsContractsScorecardsCreateScorecardRequest, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public scorecardsPost(body?: ModulesScorecardsEndpointsContractsScorecardsCreateScorecardRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public scorecardsPost(body?: ModulesScorecardsEndpointsContractsScorecardsCreateScorecardRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public scorecardsPost(body?: ModulesScorecardsEndpointsContractsScorecardsCreateScorecardRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/scorecards`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a Scorecard.
     * Removes a Scorecard using the Scorecard identifier.
     * @param scorecardId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public scorecardsScorecardIdDelete(scorecardId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public scorecardsScorecardIdDelete(scorecardId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public scorecardsScorecardIdDelete(scorecardId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public scorecardsScorecardIdDelete(scorecardId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (scorecardId === null || scorecardId === undefined) {
            throw new Error('Required parameter scorecardId was null or undefined when calling scorecardsScorecardIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/scorecards/${encodeURIComponent(String(scorecardId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Marks a Scorecard as Official or Not Official.
     * Marks a Scorecard as Official or Not Official based on the Scorecard identifer and MarkOfficialRequest.
     * @param scorecardId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public scorecardsScorecardIdMarkOfficialPut(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScorecardsMarkScorecardOfficialRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public scorecardsScorecardIdMarkOfficialPut(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScorecardsMarkScorecardOfficialRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public scorecardsScorecardIdMarkOfficialPut(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScorecardsMarkScorecardOfficialRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public scorecardsScorecardIdMarkOfficialPut(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScorecardsMarkScorecardOfficialRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (scorecardId === null || scorecardId === undefined) {
            throw new Error('Required parameter scorecardId was null or undefined when calling scorecardsScorecardIdMarkOfficialPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/scorecards/${encodeURIComponent(String(scorecardId))}/mark-official`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Marks a Scorecard as Verified or Not Verified.
     * Marks a Scorecard as Verified or Not Verified based on the Scorecard identifer and MarkVerifiedRequest.
     * @param scorecardId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public scorecardsScorecardIdMarkVerifiedPut(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScorecardsMarkScorecardVerifiedRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public scorecardsScorecardIdMarkVerifiedPut(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScorecardsMarkScorecardVerifiedRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public scorecardsScorecardIdMarkVerifiedPut(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScorecardsMarkScorecardVerifiedRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public scorecardsScorecardIdMarkVerifiedPut(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScorecardsMarkScorecardVerifiedRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (scorecardId === null || scorecardId === undefined) {
            throw new Error('Required parameter scorecardId was null or undefined when calling scorecardsScorecardIdMarkVerifiedPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/scorecards/${encodeURIComponent(String(scorecardId))}/mark-verified`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a Scorecard.
     * Updates a Scorecard based on the Scorecard identifer and UpdateScorecardRequest.
     * @param scorecardId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public scorecardsScorecardIdPut(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScorecardsUpdateScorecardRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public scorecardsScorecardIdPut(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScorecardsUpdateScorecardRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public scorecardsScorecardIdPut(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScorecardsUpdateScorecardRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public scorecardsScorecardIdPut(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScorecardsUpdateScorecardRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (scorecardId === null || scorecardId === undefined) {
            throw new Error('Required parameter scorecardId was null or undefined when calling scorecardsScorecardIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/scorecards/${encodeURIComponent(String(scorecardId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Score.
     * Creates a Score based on the Scorecard identifier and the CreateScoreRequest request.
     * @param scorecardId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public scorecardsScorecardIdScoresPost(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScoresCreateScoreRequestModel, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public scorecardsScorecardIdScoresPost(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScoresCreateScoreRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public scorecardsScorecardIdScoresPost(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScoresCreateScoreRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public scorecardsScorecardIdScoresPost(scorecardId: string, body?: ModulesScorecardsEndpointsContractsScoresCreateScoreRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (scorecardId === null || scorecardId === undefined) {
            throw new Error('Required parameter scorecardId was null or undefined when calling scorecardsScorecardIdScoresPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/scorecards/${encodeURIComponent(String(scorecardId))}/scores`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a Score.
     * Removes a Score using the Score identifier.
     * @param scorecardId 
     * @param scoreId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public scorecardsScorecardIdScoresScoreIdDelete(scorecardId: string, scoreId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public scorecardsScorecardIdScoresScoreIdDelete(scorecardId: string, scoreId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public scorecardsScorecardIdScoresScoreIdDelete(scorecardId: string, scoreId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public scorecardsScorecardIdScoresScoreIdDelete(scorecardId: string, scoreId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (scorecardId === null || scorecardId === undefined) {
            throw new Error('Required parameter scorecardId was null or undefined when calling scorecardsScorecardIdScoresScoreIdDelete.');
        }

        if (scoreId === null || scoreId === undefined) {
            throw new Error('Required parameter scoreId was null or undefined when calling scorecardsScorecardIdScoresScoreIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/scorecards/${encodeURIComponent(String(scorecardId))}/scores/${encodeURIComponent(String(scoreId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a Score.
     * Updates a Score based on the Scorecard and Score identifiers and UpdateScoreRequest.
     * @param scorecardId 
     * @param scoreId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public scorecardsScorecardIdScoresScoreIdPut(scorecardId: string, scoreId: string, body?: ModulesScorecardsEndpointsContractsScoresUpdateScoreRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public scorecardsScorecardIdScoresScoreIdPut(scorecardId: string, scoreId: string, body?: ModulesScorecardsEndpointsContractsScoresUpdateScoreRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public scorecardsScorecardIdScoresScoreIdPut(scorecardId: string, scoreId: string, body?: ModulesScorecardsEndpointsContractsScoresUpdateScoreRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public scorecardsScorecardIdScoresScoreIdPut(scorecardId: string, scoreId: string, body?: ModulesScorecardsEndpointsContractsScoresUpdateScoreRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (scorecardId === null || scorecardId === undefined) {
            throw new Error('Required parameter scorecardId was null or undefined when calling scorecardsScorecardIdScoresScoreIdPut.');
        }

        if (scoreId === null || scoreId === undefined) {
            throw new Error('Required parameter scoreId was null or undefined when calling scorecardsScorecardIdScoresScoreIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/scorecards/${encodeURIComponent(String(scorecardId))}/scores/${encodeURIComponent(String(scoreId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes all scores for a round.
     * Removes every score associated with the specified tournament round.
     * @param tournamentId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdRoundsRoundIdScoresDelete(tournamentId: string, roundId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesScorecardsApplicationScoresRemoveScoresForRoundRemoveScoresForRoundResponse>;
    public tournamentsTournamentIdRoundsRoundIdScoresDelete(tournamentId: string, roundId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesScorecardsApplicationScoresRemoveScoresForRoundRemoveScoresForRoundResponse>>;
    public tournamentsTournamentIdRoundsRoundIdScoresDelete(tournamentId: string, roundId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesScorecardsApplicationScoresRemoveScoresForRoundRemoveScoresForRoundResponse>>;
    public tournamentsTournamentIdRoundsRoundIdScoresDelete(tournamentId: string, roundId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdRoundsRoundIdScoresDelete.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling tournamentsTournamentIdRoundsRoundIdScoresDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesScorecardsApplicationScoresRemoveScoresForRoundRemoveScoresForRoundResponse>('delete',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/rounds/${encodeURIComponent(String(roundId))}/scores`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
